import { useState } from 'react'
import './Recharge.css'

const Recharge = () => {
  const [serviceType, setServiceType] = useState('mobile')
  const [formData, setFormData] = useState({
    number: '',
    amount: '',
    operator: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    // TODO: Implement recharge logic
    console.log('Recharge:', { serviceType, ...formData })
  }

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>Recharge & Bill Payment</h1>
          <p className="page-subtitle">Recharge mobile, DTH, and pay utility bills</p>
        </div>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Quick Recharge</h2>
          </div>
          <div className="service-tabs">
            <button
              className={`service-tab ${serviceType === 'mobile' ? 'active' : ''}`}
              onClick={() => setServiceType('mobile')}
            >
              Mobile
            </button>
            <button
              className={`service-tab ${serviceType === 'dth' ? 'active' : ''}`}
              onClick={() => setServiceType('dth')}
            >
              DTH
            </button>
            <button
              className={`service-tab ${serviceType === 'utility' ? 'active' : ''}`}
              onClick={() => setServiceType('utility')}
            >
              Utility
            </button>
          </div>
          <form onSubmit={handleSubmit} className="recharge-form">
            <div className="form-group">
              <label>{serviceType === 'mobile' ? 'Mobile Number' : serviceType === 'dth' ? 'DTH Number' : 'Customer ID'}</label>
              <input
                type="text"
                value={formData.number}
                onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                placeholder={`Enter ${serviceType === 'mobile' ? 'mobile' : serviceType === 'dth' ? 'DTH' : 'customer'} number`}
                required
              />
            </div>
            {serviceType === 'mobile' && (
              <div className="form-group">
                <label>Operator</label>
                <select
                  value={formData.operator}
                  onChange={(e) => setFormData({ ...formData, operator: e.target.value })}
                  required
                >
                  <option value="">Select Operator</option>
                  <option value="airtel">Airtel</option>
                  <option value="jio">Jio</option>
                  <option value="vi">Vi</option>
                  <option value="bsnl">BSNL</option>
                </select>
              </div>
            )}
            <div className="form-group">
              <label>Amount (₹)</label>
              <input
                type="number"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                placeholder="Enter amount"
                min="1"
                required
              />
            </div>
            <button type="submit" className="btn-primary btn-full">Proceed to Pay</button>
          </form>
        </div>

        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Quick Amounts</h2>
          </div>
          <div className="quick-amounts">
            {[10, 20, 50, 100, 200, 500].map(amount => (
              <button
                key={amount}
                className="amount-btn"
                onClick={() => setFormData({ ...formData, amount: amount.toString() })}
              >
                ₹{amount}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Recharge


